import { Text } from '@chakra-ui/react'
import { BaseLabel, colors } from '@hb/shared'
import { FC } from 'react'
import { useInputSize } from './Shared/sizes'

const Label: FC<BaseLabel> = ({ text, style }) => (
  <Text as="span" whiteSpace="pre-wrap" style={style}>
    {text}
  </Text>
)

const renderLabel = (label: BaseLabel, index?: number) =>
  typeof label === 'string' ? (
    <Label key={`label_${index}`} text={label} />
  ) : (
    <Label key={`label_${index}`} {...label} />
  )

const Labels: FC<{ labels?: BaseLabel[] }> = ({ labels }) => {
  const size = useInputSize()
  if (!labels) return null
  return (
    <Text
      mt={size === 'xs' || size === 'sm' ? 0.5 : 1}
      fontFamily="hero-new"
      color={colors.green.hex}>
      {labels.map((l, index) => renderLabel(l, index))}
    </Text>
  )
}

export default Labels
